<template>
  <div id="dashboard">
    <div class="block block-rounded">
      <!-- <div class="block-header block-header-default">
        <h3 class="block-title">停车费率管理</h3>
        <div class="block-options">
          <button
            v-if="addBtn"
            type="button"
            class="btn-block-option add-btn mr-2"
            data-toggle="modal"
            @click="create(true, {})"
          >
            <i class="fa fa-plus mr-1"></i> 新增
          </button>
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </div>
      </div>-->
      <!-- <div class="block-content block-content-full"> -->
      <div class="dataTables_wrapper dt-bootstrap4 no-footer">
        <div class="row mb-1">
          <div class="col-12 col-md-4 text-center text-md-left">
            <pageSize @changePageSize="changePageSize"></pageSize>
          </div>
          <div class="col-12 col-md-4 text-center text-md-center" v-show="!isMobile">
            <div class="dt-buttons">
              <button
                class="dt-button buttons-copy buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                tabindex="0"
                aria-controls="DataTables_Table_1"
                data-clipboard-text
                @click="copy()"
                type="button"
                id="copybtnStop"
              >
                <span>复制</span>
              </button>
              <button
                class="dt-button buttons-csv buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                @click="exportCSV()"
                type="button"
              >
                <span>导出</span>
              </button>
              <button
                class="dt-button buttons-print btn btn-sm btn-primary mr-2 pding-btn"
                @click="print()"
              >
                <span>打印</span>
              </button>
            </div>
          </div>
          <div class="col-12 col-md-4 text-center text-md-right">
            <div class="dataTables_filter">
              <label>
                <input
                  type="search"
                  class="form-control"
                  placeholder="搜索"
                  v-model="key"
                  @keyup.enter="search()"
                />
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="table-responsive">
              <section ref="print">
                <table
                  class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                >
                  <thead>
                    <tr>
                      <th
                        class="text-center sorting"
                        @click="getList('ID',$event)"
                        style="width: 60px; min-width:60px"
                      >#</th>
                      <th
                        class="text-left sorting"
                        @click="getList('CARPORT_NAME',$event)"
                        style="min-width:90px;"
                      >车棚名称</th>
                      <th
                        class="text-left sorting"
                        @click="getList('CELL_NAME',$event)"
                        style="min-width:90px;"
                      >所属小区</th>
                      <th
                        class="text-left sorting"
                        @click="getList('BILLING_TYPE',$event)"
                        style="min-width:100px;"
                      >费率类型</th>
                      <th
                        class="text-left sorting"
                        @click="getList('WITHHOLDING_DEPOSIT',$event)"
                        style="min-width:120px;"
                      >预扣押金(元)</th>
                      <th
                        class="text-left sorting"
                        @click="getList('COST',$event)"
                        style="min-width:120px;"
                      >日停车费(元)</th>
                      <th
                        class="text-center no-print"
                        style="width: 100px;min-width: 100px;"
                        v-if="editBtn"
                      >操作</th>
                    </tr>
                  </thead>
                  <tbody v-if="agents.length">
                    <tr v-for="(agent, i) in agents" :key="i">
                      <td class="text-center">{{ i + 1 }}</td>
                      <td class="text-left">{{ agent.CARPORT_NAME }}</td>
                      <td class="text-left">{{ agent.CELL_NAME }}</td>
                      <td class="text-left">{{showType(agent.BILLING_TYPE)}}</td>
                      <td
                        class="text-left"
                      >{{agent.WITHHOLDING_DEPOSIT==0?"免费":changeTwoDecimal(agent.WITHHOLDING_DEPOSIT)}}</td>
                      <td class="text-left">{{ agent.COST==0?"免费":changeTwoDecimal(agent.COST) }}</td>
                      <td class="text-center no-print" v-if="editBtn">
                        <div class="btn-group">
                          <button
                            v-if="editBtn"
                            type="button"
                            class="btn btn-primary js-tooltip-enabled"
                            data-toggle="modal"
                            title="查看"
                            @click="create(false, agent)"
                            data-original-title="Edit"
                          >
                            <i class="fa fa-search"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="7">查无数据</td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-5 text-center text-md-left" v-show="!isMobile">
            <div class="dataTables_info" role="status" aria-live="polite">
              页数
              <strong>{{ page }}</strong> /
              <strong>{{ totalPage }}</strong>
            </div>
          </div>
          <div class="col-sm-12 col-md-7 text-center text-md-right">
            <div class="dataTables_paginate paging_full_numbers">
              <el-pagination
                v-if="agents && agents.length"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-size="pageSize"
                :small="isMobile"
                :pager-count="pagerCount"
                :layout="isMobile ? 'prev, pager, next':'total, prev, pager, next'"
                :total="total"
                background
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>
    <div
      class="modal fade"
      id="modal-default-normal-stopRateEdit"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-normal-stopRateEdit"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{created ? '新增停车费率' : '停车费率详情'}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <div class="form-group">
                <label for="cell-sel" class="col-sm-5 control-label">所在区域</label>
                <div class="col-sm-12">
                  <select class="form-control width-33" v-model="pro" :disabled="!created">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in provinceList"
                      :key="index"
                      :value="item.DISTRICT_CODE"
                    >{{item.DISTRICT_NAME}}</option>
                  </select>
                  <select class="form-control width-33" v-model="city" :disabled="!created">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in cityList"
                      :key="index"
                      :value="item.DISTRICT_CODE"
                    >{{item.DISTRICT_NAME}}</option>
                  </select>
                  <select class="form-control width-33" v-model="dis" :disabled="!created">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in districtList"
                      :key="index"
                      :value="item.DISTRICT_CODE"
                    >{{item.DISTRICT_NAME}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-12 control-label">小区名称</label>
                <div class="col-sm-12">
                  <select
                    class="form-control"
                    style="display:inline-block;"
                    v-model="form.cellId"
                    :disabled="!created"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in cellList"
                      :key="index"
                      :value="item.CELL_ID"
                    >{{item.CELL_NAME}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  车棚名称
                  <span class="input-required" v-show="created">*</span>
                </label>
                <div class="col-sm-12">
                  <el-select
                    filterable
                    placeholder="请选择"
                    style="width: 100%;"
                    v-model="form.carportId"
                    :disabled="!created"
                  >
                    <el-option
                      v-for="item in carportList"
                      :key="item.CARPORT_ID"
                      :label="item.CARPORT_NAME"
                      :value="item.CARPORT_ID"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  费率类型
                  <span class="input-required" v-show="created">*</span>
                </label>
                <div class="col-sm-12">
                  <select :disabled="!created" class="form-control" v-model="form.billingType">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in billingTypeList"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">预扣押金(元)</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="16"
                    placeholder="默认免费"
                    v-model="form.withholdingDeposit"
                    disabled
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">日停车费(元)</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="16"
                    v-model="form.cost"
                    placeholder="默认免费"
                    disabled
                  />
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <!-- <button type="button" class="btn btn-sm btn-primary btn-sm-h" @click="submit()">保存</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from "../../../Util.js";
import pageSize from "../../../components/pageSize";
export default {
  name: "index",
  data() {
    return {
      agents: [],
      entry: {},
      setToday: new Date(),
      starttime: "",
      endtime: "",
      key: "",
      pro: "",
      city: "",
      dis: "",
      provinceList: [],
      cityList: [],
      districtList: [],
      cellList: [],
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      created: false,
      form: {
        carportId: "",
        billingType: "",
        withholdingDeposit: "",
        cost: "",
        remark: "",
        cellId: ""
      },
      clipboard: null,
      sorting: "",
      orderBy: false,
      carportList: [],
      billingTypeList: [
        {
          value: 2,
          label: "临时停车"
        }
      ],
      addBtn: Util.isHavePerm("carPort/insertCarportStopRate"),
      editBtn: Util.isHavePerm("carPort/updateCarportStopRate")
    };
  },
  components: {
    pageSize
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    regionParams() {
      return this.$store.state.regionParams;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getList();
        }
      },
      immediate: true,
      deep: true
    },

    key(val, oldVal) {
      if (val.length == 0) {
        this.getList();
      }
    },
    "form.withholdingDeposit"(val, oldVal) {
      this.form.withholdingDeposit = Util.testNumberFn(
        val,
        "inputChangeTwoDecimal"
      );
    },
    "form.cost"(val, oldVal) {
      this.form.cost = Util.testNumberFn(val, "inputChangeTwoDecimal");
    }
  },
  mounted() {
    setTimeout(() => {
      Dashmix.helpers(["flatpickr", "datepicker"]);
    }, 1000);
    this.getList();
    this.copy();
    this.searchCarport();
  },
  methods: {
    changeTwoDecimal(val) {
      return Util.changeTwoDecimal(val);
    },
    showType(str) {
      switch (str) {
        case "1":
          return "包月";
        case "2":
          return "临时停车";
      }
    },
    searchCarport() {
      this.$http.get(`${Util.searchURL}/Carport/ListByAll?key=`).then(
        res => {
          if (res.data.code === 200) {
            this.carportList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    changePageSize(val) {
      this.pageSize = val;
      this.page = 1;
    },
    create(bool, item) {
      jQuery("#modal-default-normal-stopRateEdit").modal("show");
      if (bool) {
        this.created = true;
        this.form = {
          carportId: "",
          billingType: "",
          withholdingDeposit: "",
          cost: "",
          remark: ""
        };
      } else {
        Util.displayAreaCell(item.CELL_ID, this, true, true);
        this.created = false;
        this.form = {
          carportId: item.CARPORT_ID,
          billingType: item.BILLING_TYPE,
          withholdingDeposit: this.changeTwoDecimal(item.WITHHOLDING_DEPOSIT),
          cost: this.changeTwoDecimal(item.COST),
          cellId: item.CELL_ID
        };
      }
    },
    submit() {
      let url = "";
      if (this.created) {
        url = `${Util.operateURL}/carPort/insertCarportStopRate`;
      } else {
        url = `${Util.operateURL}/carPort/updateCarportStopRate`;
      }
      this.$http.post(url, this.form).then(
        res => {
          if (res.data.code === 200) {
            Util.message("succ", res.data.desc);
            jQuery("#modal-default-normal-stopRateEdit").modal("hide");
            this.getList();
          } else {
            Util.message("err", res.data.desc);
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    selectVal(ele) {
      this.selected = ele.target.value;
    },

    getList(sorting, that) {
      let params = {};
      if (this.key.length > 0) {
        params["key"] = this.key.trim();
      }

      if (sorting != undefined || this.sorting.length > 0) {
        this.sorting = sorting == undefined ? this.sorting : sorting;
        params["sort"] = this.sorting;
        params["orderBy"] = this.orderBy;

        if (that != undefined && that.currentTarget != undefined) {
          var obj = that.currentTarget;
          if (
            $(obj).is(".sorting_asc") ||
            $(obj).is(".sorting_desc") ||
            $(obj).is(".sorting")
          ) {
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_asc");
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_desc");
            $(obj).addClass(this.orderBy ? "sorting_asc" : "sorting_desc");
            this.orderBy = !this.orderBy;
            params["orderBy"] = this.orderBy;
          }
        }
      }

      this.$http
        .get(
          `${Util.searchURL}/Carport/ListByStopRate/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params
          }
        )
        .then(res => {
          if (res.data.code === 200) {
            this.agents = res.data.data.data;
            this.total = res.data.data.pageInfo.total;
          }
        });
    },
    exportCSV() {
      let params = {};
      if (this.key) {
        params["key"] = this.key.trim();
      }
      // params['key'] =  ''
      params["down"] = 1;
      this.$http
        .get(
          `${Util.searchURL}/Carport/ListByStopRate/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params,
            responseType: "blob"
          }
        )
        .then(res => {
          if (res.status === 200) {
            Util.ExportCSV(res);
          }
        });
    },
    print() {
      this.$print(this.$refs.print);
    },
    copy() {
      let copyStr = document.getElementsByTagName("section")[1].innerText;
      var btn = document.getElementById("copybtnStop");
      btn.setAttribute("data-clipboard-text", copyStr);
      this.clipboard = new ClipboardJS(btn);
      this.clipboard.on("success", e => {
        Util.message("succ", "复制成功");
        this.clipboard.destroy();
        e.clearSelection();
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    search() {
      this.page = 1;
      this.getList();
    }
  }
};
</script>